// Dati Ufficiali TerniEnergia Progetti

export const companyData = {
  name: "TerniEnergia Progetti",
  fullName: "TerniEnergia Progetti S.r.l.",
  tagline: "",
  description: "Società italiana specializzata nella progettazione, realizzazione, gestione e manutenzione di impianti fotovoltaici di media e grande taglia per clienti industriali e utility.",
  longDescription: "Opera come general contractor EPC full-scope e come partner qualificato per servizi di Operation & Maintenance e Asset Management, coprendo l'intero ciclo di vita dell'impianto, dallo sviluppo alla gestione di lungo periodo.",
  legalInfo: {
    fullName: "TERNIENERGIA PROGETTI S.R.L.",
    address: "Via Giuseppe Garibaldi, 43",
    city: "05100 Terni (TR)",
    vat: "01619830555",
    pec: "terniprogetti@arubapec.it",
    email: "info@ternienergia.com"
  },
  keyNumbers: [
    { value: "614 MWp", label: "Track record industriale in Italia e all'estero" },
    { value: "50+", label: "Impianti in gestione O&M (2026)" },
    { value: "ISO", label: "9001:2015 e 45001:2018" }
  ],
  founding: {
    year: "2018",
    parent: "Terni Grandi Impianti S.r.l.",
    ownership: "Interamente controllata"
  },
  certifications: [
    {
      name: "ISO 9001:2015",
      description: "Sistema di gestione per la qualità",
      issuer: "TÜV AUSTRIA",
      number: "20001230008931",
      validUntil: "2026-05-30",
      scope: "Installazione, manutenzione e monitoraggio di impianti di generazione elettrica da fonte rinnovabile solare fotovoltaica"
    },
    {
      name: "ISO 45001:2018",
      description: "Sistema di gestione per la salute e sicurezza sul lavoro",
      issuer: "TÜV AUSTRIA",
      number: "20152230008933",
      validUntil: "2026-05-30",
      scope: "Installazione, manutenzione e monitoraggio di impianti di generazione elettrica da fonte rinnovabile solare fotovoltaica"
    }
  ]
};

export const services = [
  {
    id: 1,
    title: "EPC Full Scope",
    shortDesc: "Progettazione, procurement e costruzione chiavi in mano",
    description: "Engineering Procurement & Construction full-scope, dalla progettazione tecnica e autorizzativa alla realizzazione chiavi in mano di impianti fotovoltaici utility-scale, con montaggi meccanici ed elettrici e attività di Balance of Plant.",
    image: "/photo6.jpeg",
    icon: "Hammer"
  },
  {
    id: 2,
    title: "Operation & Maintenance",
    shortDesc: "Gestione operativa e manutenzione avanzata",
    description: "Modello O&M evoluto con soluzioni digitali avanzate, sistemi di monitoraggio intelligenti e piena integrazione tra attività on-site e tecnologie di controllo per massimizzare le performance.",
    image: "/photo5.jpeg",
    icon: "Wrench"
  },
  {
    id: 3,
    title: "Asset Management",
    shortDesc: "Ottimizzazione e valorizzazione degli asset fotovoltaici",
    description: "Accompagnamento lungo l'intero ciclo di vita dell'impianto con servizi di revamping, repowering e sistemi di monitoraggio per massimizzare produzione e redditività nel lungo periodo.",
    image: "/photo4.jpeg",
    icon: "TrendingUp"
  }
];

export const trackRecord = {
  totalMWp: 614,
  managedPlants: "50+",
  period: "2026",
  countries: [
    { 
      name: "Italia", 
      mwp: 366, 
      projects: 20, 
      lat: 42.5, 
      lng: 12.5,
      gallery: [
        { name: "EG SOLE", mwp: "49.20", location: "Lazio", image: "/projects/image61.jpeg", client: "Enfinity/Circet Italia" },
        { name: "OTTANA", mwp: "89", location: "Sardegna", image: "/projects/image62.jpeg", client: "Acea Solar/Circet Italia" },
        { name: "MARCONI", mwp: "38.55", location: "Emilia", image: "/projects/image64.jpeg", client: "Circet Italia" },
        { name: "CODIGORO", mwp: "28.76", location: "Emilia-Romagna", image: "/projects/image67.png", client: "Circet Italia" },
        { name: "CONTESSA ENTELLINA", mwp: "57.85", location: "Sicilia", image: "/projects/image69.png", client: "X-Elio Italia/Circet Italia" },
        { name: "CIMINNA", mwp: "67.42", location: "Sicilia", image: "/projects/image74.png", client: "Circet Italia" },
        { name: "VERBUND APRILIA", mwp: "61", location: "Lazio", image: "/projects/image75.png", client: "Verbund/Circet Italia" }
      ]
    },
    { 
      name: "Grecia", 
      mwp: 38.77, 
      projects: 8, 
      lat: 39.0, 
      lng: 22.0,
      gallery: []
    },
    { 
      name: "Sudafrica", 
      mwp: 158.5, 
      projects: 10, 
      lat: -30.5, 
      lng: 22.9,
      gallery: []
    },
    { 
      name: "Romania", 
      mwp: 41, 
      projects: 6, 
      lat: 45.9, 
      lng: 24.9,
      gallery: []
    },
    { 
      name: "Tunisia", 
      mwp: 10, 
      projects: 3, 
      lat: 34.0, 
      lng: 9.0,
      gallery: []
    }
  ],
  recentProjects: [
    {
      id: 1,
      name: "Impianti Utility-Scale Sicilia",
      location: "Sicilia, Italia",
      mwp: "Grandi Impianti",
      year: "2024-2025",
      status: "Realizzato",
      type: "EPC"
    },
    {
      id: 2,
      name: "Impianti Emilia-Romagna",
      location: "Emilia-Romagna, Italia",
      mwp: "Grandi Impianti",
      year: "2024-2025",
      status: "Realizzato",
      type: "EPC"
    },
    {
      id: 3,
      name: "Impianti Sardegna",
      location: "Sardegna, Italia",
      mwp: "Grandi Impianti",
      year: "2024-2025",
      status: "Realizzato",
      type: "EPC"
    }
  ]
};

export const financialData = {
  year: 2025,
  ebitda: 610148,
  ebitdaDisplay: "€610K+",
  ebitdaMargin: "11.3%",
  netProfit: 82472,
  netProfitDisplay: "€82K",
  equity: 1928349,
  equityDisplay: "€1.93M",
  totalAssets: 4090495
};

export const newsData = [
  {
    id: 2,
    title: "Oltre 40 impianti fotovoltaici in gestione O&M nel biennio 2024-2025",
    category: "Progetti",
    date: "2025-01-20",
    excerpt: "Consolidamento del posizionamento nel segmento utility-scale con portfolio multi-impianto su territorio nazionale.",
    image: "/photo7.jpeg"
  },
  {
    id: 3,
    title: "Completati grandi impianti in Sicilia, Emilia-Romagna e Sardegna",
    category: "Progetti",
    date: "2024-12-10",
    excerpt: "Realizzazione di numerosi progetti utility-scale nel biennio 2024-2025 in Italia.",
    image: "/photo2.jpeg"
  }
];

export const governanceData = {
  ownership: {
    parent: "Terni Grandi Impianti S.r.l.",
    control: "100%"
  },
  board: [
    {
      name: "Vincenzo Peponi",
      role: "Presidente Esecutivo",
      bio: "Esperienza pluriennale nel settore energetico e fotovoltaico utility-scale"
    },
    {
      name: "Laura Neri",
      role: "Amministratore Delegato",
      bio: "Competenze in sviluppo industriale e gestione operativa di progetti EPC"
    }
  ],
  certifications: [
    "ISO 9001:2015 - Sistema di Gestione Qualità",
    "ISO 45001:2018 - Salute e Sicurezza sul Lavoro"
  ],
  codeOfEthics: true,
  governanceModel: "Orientato alla creazione di valore sostenibile nel lungo periodo"
};

export const documentsData = [
  {
    id: 1,
    title: "Company Profile 2026",
    category: "Presentazione Aziendale",
    size: "15 MB",
    format: "PPTX",
    url: "/Presentazione_Aziendale_TEP.pptx"
  },
  {
    id: 2,
    title: "Certificazione ISO 9001:2015",
    category: "Certificazioni",
    size: "150 KB",
    format: "PDF",
    url: "https://customer-assets.emergentagent.com/job_utility-scale-power/artifacts/ntniskls__e_CERT_9001_2015_EN_TerniEnergiaProgetti.pdf"
  },
  {
    id: 3,
    title: "Certificazione ISO 45001:2018",
    category: "Certificazioni",
    size: "148 KB",
    format: "PDF",
    url: "https://customer-assets.emergentagent.com/job_utility-scale-power/artifacts/c2lx9y1x__e_CERT_45001_2018_EN_TerniEnergiaProgetti.pdf"
  },
  {
    id: 5,
    title: "Codice Etico TEP 2025",
    category: "Governance",
    size: "435 KB",
    format: "PDF",
    url: "/codice-etico.pdf"
  }
];

export const omSolutions = {
  title: "O&M e Soluzioni Digitali",
  description: "La proposta O&M di TerniEnergia Progetti supera il modello tradizionale, valorizzando il ruolo della manutenzione nella massimizzazione delle performance.",
  features: [
    {
      id: 1,
      title: "Sistemi di Monitoraggio Evoluti",
      description: "Integrazione completa tra attività on-site e soluzioni tecnologiche per eccellenza operativa.",
      icon: "Monitor"
    },
    {
      id: 2,
      title: "Monitoraggio Avanzato",
      description: "Aggrega e analizza dati raccolti tramite ispezioni tecniche, identifica anomalie e supporta le decisioni operative.",
      icon: "Activity"
    },
    {
      id: 3,
      title: "Gestione Interventi",
      description: "Supporto nella definizione delle priorità di intervento per massimizzare efficienza e redditività.",
      icon: "Brain"
    },
    {
      id: 4,
      title: "Integrazione Tecnologica",
      description: "Facile integrazione con tecnologie già presenti negli impianti esistenti.",
      icon: "Zap"
    }
  ]
};

export const activitiesData = [
  {
    id: 1,
    title: "Engineering Procurement & Construction",
    description: "Progettazione tecnica e autorizzativa. Procurement e coordinamento forniture con controllo filiera. Costruzione in qualità e sicurezza. Direzione lavori fino al collaudo.",
    icon: "Package"
  },
  {
    id: 2,
    title: "Balance of Plant",
    description: "Esecuzione opere meccaniche ed elettriche: strutture di supporto, tracker, opere civili, fondazioni e cavidotti. Installazione quadri elettrici e cabine di trasformazione.",
    icon: "Grid3x3"
  },
  {
    id: 3,
    title: "O&M, Revamping e Repowering",
    description: "Gestione operativa con contratti pluriennali. Manutenzione ordinaria e straordinaria. Integrazione soluzioni digitali. Revamping e repowering per migliorare efficienza.",
    icon: "Wrench"
  },
  {
    id: 4,
    title: "Monitoraggio e Performance",
    description: "Monitoraggio tecnico-funzionale con piattaforme digitali. Controllo performance in tempo reale. Interventi mirati per massimizzare produzione ed efficienza.",
    icon: "Monitor"
  }
];
